import { useEffect, useState } from 'react';
import graphqlService from '../services/graphql';

export function useProductDetailData(selectID) {
  const [loading, setLoading] = useState(false);
  const [equipmentDetail, setEquipmentDetail] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        setError(null);
        if (selectID) {
          const data = await graphqlService.getEquipmentDetailById(selectID);
          setEquipmentDetail(data);

          // 获取同款产品逻辑
          if (data) {
            let searchTerm = '';
            
            // 通用化核心词提取函数
            const getCoreModel = (str) => {
              if (!str) return '';
              let clean = str.split('|')[0]; // 移除中文
              clean = clean.replace(/[\(（].*?[\)）]/g, '').trim(); // 移除括号 (支持中英文)
              return clean.split(/\s+/)[0].toLowerCase(); // 取首词并转小写
            };

            // 1. 优先使用 model
            if (data.model) {
              searchTerm = getCoreModel(data.model);
            } 
            // 2. 其次尝试从 name 中提取核心词
            else if (data.name) {
              // 移除年份 (如 24/25, 23-24, 2024)
              searchTerm = data.name
                .replace(/\d{2}\/\d{2}/g, '')
                .replace(/\d{2}-\d{2}/g, '')
                .replace(/20\d{2}/g, '')
                .trim();
            }

            if (searchTerm && searchTerm.length >= 2) {
              try {
                // 使用普通搜索查找相关产品，可以指定品牌，结果更准确
                const searchFilters = {
                  searchText: searchTerm,
                  brands: [data.brandName],
                  categories: [data.category]
                };
                const searchResults = await graphqlService.searchEquipments(searchFilters, 0, 100);
                
                // 确保是同品牌
                const related = searchResults.filter(item => {
                  // 忽略大小写比较品牌 (虽然 searchEquipments 已经过滤了，但双重保险)
                  if (item.brandName.toLowerCase() !== data.brandName.toLowerCase()) return false;

                  // 如果当前商品有 model，则进行更智能的匹配
                  if (data.model) {
                    const coreCurrentModel = getCoreModel(data.model);
                    
                    if (item.model) {
                      const coreItemModel = getCoreModel(item.model);
                      return coreItemModel === coreCurrentModel;
                    } else {
                      // 如果 item 没有 model 字段，尝试在 name 中匹配 coreCurrentModel
                      const normalizedName = item.name.toLowerCase();
                      // 检查是否包含核心词
                      return normalizedName.includes(coreCurrentModel);
                    }
                  }

                  // 如果当前商品没有 model，则暂时只依赖搜索结果的模糊匹配 + 品牌过滤
                  return true;
                });
                
                // 按年份排序（可选，新的在前）
                related.sort((a, b) => {
                  const yearA = a.year || '';
                  const yearB = b.year || '';
                  return yearB.localeCompare(yearA);
                });

                setRelatedProducts(related);
              } catch (searchErr) {
                console.warn('Failed to fetch related products:', searchErr);
              }
            }
          }

        } else {
          setEquipmentDetail(null);
          setRelatedProducts([]);
        }
      } catch (err) {
        console.error('Failed to fetch home data:', err);
        setError(err.message);
        setEquipmentDetail(null);
        setRelatedProducts([]);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [selectID]);

  return { loading, equipmentDetail, relatedProducts, error };
} 